import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Navigate,NavLink,Outlet  } from 'react-router-dom';
import Athalogo from './images/adminlogo.jpg';
export default class FormLayout extends Component {	

constructor(props) {
    super(props)
    this.state = {}
}

render() {


  return (
 <div className="formtab">
     <div className="loginbg">
	  <div className="loginbglogo"> <div className="loginpad">
	  <img src={Athalogo} alt="Atha Yoga" />
	</div>   </div> <div className="loginforms">
	 <Outlet/></div> 
	 <div className="clear"></div>
	 </div>
   </div>
);
}   
}







